import { get } from 'lodash';
import { extractButton } from '../../utils/elements';
import { ButtonAlign } from '../../types';
export var getButton = function (_a) {
    var region = _a.region, css = _a.css, _b = _a.isRtl, isRtl = _b === void 0 ? false : _b, _c = _a.experiments, experiments = _c === void 0 ? {} : _c;
    var buttonStyles = get(region, 'data.styles.button', {});
    var defaultStyles = css['so-global-b1-mix'];
    var button = extractButton({
        customStyles: buttonStyles,
        defaultStyles: defaultStyles,
        experiments: experiments,
        isRtl: isRtl,
        region: region,
        defaultButtonAlignment: isRtl ? ButtonAlign.right : ButtonAlign.left,
    });
    return button;
};
//# sourceMappingURL=get-button.js.map